@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

@font-face {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src:
    local('Poppina'),
    url('../../utils/Poppins/Poppins-Regular.ttf') format('truetype');
}

@font-face {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src:
    local('Poppina'),
    url('../../utils/Poppins/Poppins-SemiBold.ttf') format('truetype');
}

@font-face {
  font-family: Prompt;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src:
    local('Prompt'),
    url('../../utils/Prompt/Prompt-Regular.ttf') format('truetype');
}

@font-face {
  font-family: Prompt;
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src:
    local('Prompt'),
    url('../../utils/Prompt/Prompt-Medium.ttf') format('truetype');
}

@font-face {
  font-family: Prompt;
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src:
    local('Prompt'),
    url('../../utils/Prompt/Prompt-SemiBold.ttf') format('truetype');
}

@font-face {
  font-family: Prompt;
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src:
    local('Prompt'),
    url('../../utils/Prompt/Prompt-Bold.ttf') format('truetype');
}

$wrapper-max-width: 64rem;
$wrapper-max-width-slim: 51rem;
$wrapper-padding-xl: 10%;
$wrapper-padding-lg: 3.5rem;
$wrapper-padding-md: 2rem;
$wrapper-padding-sm: 1.5rem;
$wrapper-padding-xs: 1rem;

@mixin wrapper-width {
  max-width: $wrapper-max-width;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    max-width: unset;
    padding-left: $wrapper-padding-xl;
    padding-right: $wrapper-padding-xl;
  }

  @media (max-width: map.get($grid-breakpoints, lg)) {
    padding-left: $wrapper-padding-lg;
    padding-right: $wrapper-padding-lg;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding-left: $wrapper-padding-md;
    padding-right: $wrapper-padding-md;
  }

  @media (max-width: map.get($grid-breakpoints, sm)) {
    padding-left: $wrapper-padding-sm;
    padding-right: $wrapper-padding-sm;
  }

  @media (max-width: map.get($grid-breakpoints, xs)) {
    padding-left: $wrapper-padding-xs;
    padding-right: $wrapper-padding-xs;
  }
}

.wrapper {
  font-family: Avenir, Montserrat, Poppins, serif;
  background: linear-gradient(180deg, #2e0e51 0%, #3d1e5a 100%);
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 50px;
  overflow: hidden;

  @media (max-width: map.get($grid-breakpoints, md)) {
    background: #2e0e51;
    padding-top: 20px;
  }

  &--no-top-row {
    padding-top: 10.5rem;

    @media (max-width: map.get($grid-breakpoints, lg)) {
      padding-top: 3.75rem;
    }
  }

  &--no-top-padding {
    padding-top: 0;
  }

  &--dark {
    background: #2e0a52;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    @include wrapper-width;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin-bottom: 3rem;
    }

    &--align-left {
      align-items: flex-start;
      align-self: flex-start;
    }

    &--extra-wide {
      max-width: 78rem;
      margin: 0 auto;
      width: unset;
    }
  }

  &__top-row {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: flex-start;

    @include wrapper-width;

    margin-bottom: 3.8rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin-bottom: 3.6rem;
    }

    &--extra-spacing {
      margin-bottom: 15.75rem;

      @media (max-width: map.get($grid-breakpoints, md)) {
        margin-bottom: 3.8rem;
      }
    }
  }

  &__top-row-text {
    font-size: 1.5rem;
    font-family: Avenir, Montserrat, Poppins, serif;
    font-weight: 400;
    text-align: left;
    color: #fff;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 1rem;
    }
  }

  &__button-row {
    display: flex;

    @include wrapper-width;

    padding-top: 5rem;
    padding-bottom: 5rem;
    margin-top: auto;

    &--absolute {
      position: absolute;
      bottom: 9%;
      padding-top: 0;
      padding-bottom: 0;

      @media (max-width: map.get($grid-breakpoints, lg)) {
        position: relative;
        bottom: unset;
      }
    }

    @media (max-width: map.get($grid-breakpoints, md)) {
      padding-top: 2.125rem;
      padding-bottom: 2.25rem;
      background: #fff6;
    }

    &__button-forward--position {
      margin-left: auto;
    }
  }
}

$background-image-height: 11rem;
$background-image-height-md: 5rem;

.navigation-wrapper {
  display: inline-flex;
  gap: 16px;
  width: 100%;

  @include wrapper-width;

  margin-bottom: 2.5rem;

  @media (max-width: map.get($grid-breakpoints, md)) {
    margin-bottom: 2rem;
    gap: 8px;
  }
}

button.navigation-button {
  background: #593884;
  padding: 10px 30px;
  border: unset;
  border-radius: 4px;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0;
  color: #fff;

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding: 10px;
    font-size: 16px;
    line-height: 12px;
  }

  &:hover {
    background: #795e9b;
    text-decoration: underline;
  }

  &:focus {
    background: #593884;
    box-shadow: inset 0 0 0 2px #fff;
    outline: none;
  }

  &:last-of-type:not(:first-of-type) {
    box-shadow: inset 0 0 0 1px #c3aae2;
    color: #c3aae2;
    background: transparent;

    &:hover {
      background: transparent;
      text-decoration: underline;
      box-shadow: inset 0 0 0 1px #fff;
      color: #fff;
    }

    &:focus {
      background: transparent;
      box-shadow: inset 0 0 0 3px #fff;
      outline: none;
      color: #fff;
    }
  }
}

.logo-tilemap {
  position: absolute;
  left: -50vw;
  width: 150vw;
  height: $background-image-height;
  background-image: url('../../utils/Icons/SelvtestTilemap.svg');
  background-repeat: repeat-x;
  background-size: 10rem $background-image-height;

  @media (max-width: map.get($grid-breakpoints, md)) {
    height: $background-image-height-md;
    background-size: 4rem $background-image-height-md;
    transform: translateY(-0.5rem);
  }
}

$gradient-padding: 5rem;
$gradient-padding-md: 2rem;

.logo-gradient {
  position: relative;
  z-index: 1;
  padding: 0 $gradient-padding;
  margin-left: -$gradient-padding;
  background: linear-gradient(to left, transparent 0%, #2e0a52 20%, #2e0a52 80%, transparent 100%);

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding: 0 $gradient-padding-md;
    margin-left: -$gradient-padding-md;
  }
}
